import React from 'react';

import CuotaCategoria  from 'components/Tvendo/Sale/QuotaBPartner/Colgate/Periodo/CuotaCategoria/List.js';

export default function () {
  return <CuotaCategoria  />;
}